import React, { Component } from 'react'

import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'

import Lightbox from './lightbox'

import dj from './../css/dj.jpg'

export default class Vita extends Component {
  constructor(props) {
    super(props)
    this.state = { hidden: true, vita: '', selectedPhotoIndex: 0 }
  }

  toggle() {
    this.setState({ hidden: !this.state.hidden })
  }

  getVita(slug) {
    var url =
      (process.env.NODE_ENV === 'development'
        ? API_BASE_URL_DEV
        : API_BASE_URL_PROD) + 'vita'

    fetch(url, {})
      .then(response => response.json())
      .then(json => this.setState({ vita: json }))
  }

  componentDidMount() {
    this.getVita()
  }

  // will be called by a route change
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.slug !== this.props.slug) {
      this.getVita()
    }
  }

  setSelectedPhotoIndex(index) {
    this.setState({ selectedPhotoIndex: index })
  }

  render() {
    return (
      <div className="vita">
        <Lightbox
          photos={[{ link: dj, alt: 'Daniela Janjic Portrait' }]}
          selectedPhotoIndex={this.state.selectedPhotoIndex}
          setSelectedPhotoIndex={this.setSelectedPhotoIndex.bind(this)}
        />
        <span
          className="vita-text"
          dangerouslySetInnerHTML={{ __html: this.state.vita.Content }}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/vita.js